export const TOPICS = [
  "Stock Market Basics",
  "Technical Analysis",
  "Fundamental Analysis",
  "Options Trading",
  "Risk Management",
  "Commodities",
  "Market Psychology",
  "Investment Strategies",
  "Market Analysis",
];
